import { z } from 'zod/v4';

export const AdminCompanyProfileParamsSchema = z.object({
  forCompanyId: z.string().min(1, 'Company ID is required'),
  type: z.string().min(1, 'Profile type is required'),
});

export type AdminCompanyProfileParams = z.infer<
  typeof AdminCompanyProfileParamsSchema
>;

// `data` holds one entry per data point, each merging the data-points-lib
// definition (name, schema, sectionId, ...) with the stored answer (value,
// unit, ...) and computed isEditable/isVisible flags — loosely typed here to
// avoid duplicating that shape.
export const AdminCompanyProfileResponseSchema = z.looseObject({
  forCompanyId: z.string(),
  byCompanyId: z.string(),
  onBehalfOfCompanyId: z.string(),
  profileType: z.string(),
  data: z.record(z.string(), z.unknown()),
  isConnected: z.boolean(),
  isReverseConnected: z.boolean(),
  templateCompletionPercentage: z.number().optional(),
});

export type AdminCompanyProfile = z.infer<
  typeof AdminCompanyProfileResponseSchema
>;
